import { render, staticRenderFns } from "./BilletsReport.vue?vue&type=template&id=32ffac48"
import script from "./BilletsReport.vue?vue&type=script&lang=js"
export * from "./BilletsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports